import { Injectable } from '@angular/core';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AuthProvider } from '../../providers/auth/auth';
import { ProofServerProvider } from "../../providers/proof-server/proof-server";

import * as Config from "../../app/app.config";

/*
  Generated class for the RegistrationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class RegistrationProvider {

    private proof = null;

    constructor(
        private validatorProvider: ValidatorProvider,
        private authProvider: AuthProvider,
        private proofServerProvider: ProofServerProvider
    ) {
        console.log('Hello RegistrationProvider Provider');

        this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
          this.proof = proof;
        });
    }

    isComplete(callback = null) {
      let user = this.authProvider.getUser();

      if (callback === null) {
        return (
          ((!this.validatorProvider.isEmpty(user.address)) &&
            (!this.validatorProvider.isEmpty(user.addressNumber)) &&
            (!this.validatorProvider.isEmpty(user.addressCountry)) &&
            (!this.validatorProvider.isEmpty(user.addressCity)) &&
            (!this.validatorProvider.isEmpty(user.addressState)) &&
            (!this.validatorProvider.isEmpty(user.addressZip))) &&
          ((user.genre !== null) &&
            (user.nationality !== null) &&
            (!this.validatorProvider.isEmpty(user.birthPlace))) &&
          (!this.validatorProvider.isEmpty(user.motherName)) &&
          ((user.documentKind !== null) &&
            (!this.validatorProvider.isEmpty(user.documentCode)) &&
            (user.scholarity !== null))
        );
      } else {
        let user = this.authProvider.getUser();

        this.proofServerProvider.getById(Config.proofId).subscribe(proof => {
          if (proof.hasMandatoryDocumentation === '1' /* && user.userFiles.length === 0 */) {
            callback(false);
          }
          else {
            callback(
              ((!this.validatorProvider.isEmpty(user.address)) &&
                (!this.validatorProvider.isEmpty(user.addressNumber)) &&
                (!this.validatorProvider.isEmpty(user.addressCountry)) &&
                (!this.validatorProvider.isEmpty(user.addressCity)) &&
                (!this.validatorProvider.isEmpty(user.addressState)) &&
                (!this.validatorProvider.isEmpty(user.addressZip))) &&
              ((user.genre !== null) &&
                (user.nationality !== null) &&
                (!this.validatorProvider.isEmpty(user.birthPlace))) &&
              (!this.validatorProvider.isEmpty(user.motherName)) &&
              ((user.documentKind !== null) &&
                (!this.validatorProvider.isEmpty(user.documentCode)) &&
                (user.scholarity !== null))
            );
          }
        });
      }
    }
}



// WEBPACK FOOTER //
// ./src/providers/registration/registration.ts